import mock from './mock'


import './data/index.js'


mock.onAny().passThrough() // forwards the matched request over network
